import {eGENA_ProblemKategorie} from './ProblemKategorieABCDE'
import { eGENA_ItemGroup } from './ItemGroup';
import { getErrorString } from './Error';



export class eGENA_Item extends eGENA_ProblemKategorie {
	public label : string = "";
	public zusatzinformationen : string | undefined;
	public itemGruppe : eGENA_ItemGroup | undefined;
	public linkID : number | undefined = undefined;
	public linkText : string | undefined = undefined;

	constructor(vorlage : eGENA_ProblemKategorie | any | undefined,
				label : string,
				zusatzinformationen : string | undefined,
				itemGruppenName : string | undefined,
				itemGruppenVorlage : eGENA_ProblemKategorie | undefined,
				linkID : number | undefined,
				linkText : string | undefined

	) {
		super(vorlage);
		this.label = label;
		this.zusatzinformationen = zusatzinformationen;
		if (itemGruppenName != undefined) {
			this.itemGruppe = new eGENA_ItemGroup(itemGruppenName, itemGruppenVorlage);
		}
		this.linkID = linkID;
		this.linkText = linkText;
	}



	public static fromObjectArray(objects : any[]) : eGENA_Item[] {
		let items : eGENA_Item[] = [];

		for (const object of objects) { 
			let label : string;
			if (!('label' in object)) {
				throw eGENA_Item.getError('label', object);
			}
			label = object.label;

			let zusatzinformationen : string | undefined = undefined;
			if ('zusatzinformationen' in object) {
				zusatzinformationen = object.zusatzinformationen;
			}

			let itemGruppenName : string | undefined;
			let itemGruppenVorlage : eGENA_ProblemKategorie | undefined;
			if ('itemGruppe' in object) {
				itemGruppenVorlage = object.itemGruppe;
				if (itemGruppenVorlage === undefined) {
					
				}
				else {
					if (!('name' in itemGruppenVorlage)) {
						throw eGENA_Item.getError('itemGruppe.name', object);
					}
					itemGruppenName = object.itemGruppe.name;
				}				
			}

			let linkID : number | undefined;
			if ('linkID' in object) {
				try {
					linkID = parseInt(object.linkID);
				} catch (e) {
					throw eGENA_Item.getTypeError('linkID', 'number', e, object);
				}
				if (isNaN(linkID)) {
					throw eGENA_Item.getTypeError('linkID', 'number', "NaN", object);
				}
			}

			let	linkText : string | undefined = undefined;
			if ('linkText' in object) {
				linkText = object.linkText;
			}


			items.push(new eGENA_Item(object, label, zusatzinformationen, itemGruppenName, itemGruppenVorlage, linkID, linkText));
		}


		return items;
	}


	private static getError(attribute : string, object : any) : Error {
		return new Error("eGENA_Item.fromObjectArray: nicht im erwarteten Format, das Attribut '" + attribute + "' ist nicht definiert!\nRohdaten: " + JSON.stringify(object, null, 4));
	}  


	private static getTypeError(attribute : string, expectedClass : string, error : any, object : any) : Error {
		return new Error("eGENA_Item.fromObjectArray: nicht im erwarteten Format, das Attribut '" + attribute + "' ist nicht vom erwarteten Typ '" + expectedClass + "': " + getErrorString(error) + "'!\nRohdaten: " + JSON.stringify(object, null, 4));
	}  

}



// WEBPACK FOOTER //
// ./src/visionet/Item.ts